import { Routes } from '@angular/router';


import { notFoundComponent } from './pages/00-errors/404/404.component';
import { environment } from '../environments/environment';
// Guards
import { ArchitectRouteGuard, ArtisanRouteGuard, ExternalRouteGuard, NewAccountArchitectRouteGuard, SubscriptionArchitectGuard, LoggedRouteGuard, DemoRouteGuard  } from './_utils/_guard';

// Import the billing management component
import { BillingManagementComponent } from './pages/04-architect/00-profile/archi-profil/billing-management/billing-management.component';
import { PreFreeLicenceArchitectPageComponent } from './pages/04-architect/00-profile/pre-free-licence-architect-page/pre-free-licence-architect-page.component';

export const routes: Routes = [
  // Architect
  { 
    path: 'architect',
    children: [
      {
        path: 'appel-offres',
        loadComponent: () => import('./pages/04-architect/00-profile/archi-appel-offres/archi-appel-offres.component').then(c => c.ArchiAppelOffresComponent),
        canActivate: [ArchitectRouteGuard]
      },
      {
        path: 'appel-offre/:id',
        loadComponent: () =>
          import('./pages/04-architect/00-profile/archi-appel-offre-detail/archi-appel-offre-detail.component').then(
            c => c.ArchiAppelOffreDetailComponent
          ),
        canActivate: [ArchitectRouteGuard]
      },
      { 
        path: 'subscribe', 
        loadComponent: () => import('./pages/02-signup/signup-architect/signup-architect.component').then(c => c.SignupArchitectComponent),
        canActivate: [ExternalRouteGuard] 
      },
      { 
        path: 'carnet-adresses', 
        loadComponent: () => import('./pages/04-architect/00-profile/carnet-adresses/carnet-adresses.component').then(c => c.CarnetAdressesComponent),
        canActivate: [ArchitectRouteGuard]
      },
      // { path: 'subscribe', component: ArchiSubscribe1Component,canActivate: [ExternalRouteGuard] },
      // { path: 'subscribe/verification', component: ArchiSubscribeQuestionComponent,canActivate: [ExternalRouteGuard] },
      // { path: 'subscribe2', component: ArchiSubscribe2Component,canActivate: [ArchitectRouteGuard] },
      { 
        path: 'subscribe2', 
        loadComponent: () => import('./pages/02-signup/architect-new-subscribe/architect-new-subscribe.component').then(c => c.ArchitectNewSubscribeComponent),
        canActivate: [SubscriptionArchitectGuard] 
      },
      { 
        path: 'collaborateur/subscribe1/:userId', 
        loadComponent: () => import('./pages/02-signup/collaborateur-subscribe1/collaborateur-subscribe1.component').then(c => c.CollaborateurSubscribe1Component),
        canActivate: [ExternalRouteGuard] 
      },
      // { path: 'subscribe5', component: ArchiSubscribe5Component ,canActivate: [ArchitectRouteGuard]},
      { 
        path: 'my-consultations', 
        loadComponent: () => import('./pages/04-architect/01-projects/architect-my-consultation/architect-my-consultation.component').then(c => c.ArchitectMyConsultationComponent),
        canActivate: [ArchitectRouteGuard]
      },
      { 
        path: 'new-ce-project',
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/04-architect/01-projects/archi-new-ce/archi-new-ce.component').then(c => c.ArchiNewCeComponent),
            canActivate: [ArchitectRouteGuard]
          },
          {
            path: ':projectId',
            loadComponent: () => import('./pages/04-architect/01-projects/archi-new-ce/archi-new-ce.component').then(c => c.ArchiNewCeComponent),
            canActivate: [ArchitectRouteGuard]
          }
        ],
      },
      {
        path: 'import-dce',
        loadComponent: () => import('./pages/04-architect/01-projects/archi-import-dce/archi-import-dce.component').then(c => c.ArchiImportDceComponent),
        canActivate: [ArchitectRouteGuard]
      },
      {
        path: 'import-dce/:projectId',
        loadComponent: () => import('./pages/04-architect/01-projects/archi-import-dce/archi-import-dce.component').then(c => c.ArchiImportDceComponent),
        canActivate: [ArchitectRouteGuard]
      },
      {
        path: 'demo-page',
        loadComponent: () => import('./pages/04-architect/00-profile/pre-free-licence-architect-page/pre-free-licence-architect-page.component').then(c => c.PreFreeLicenceArchitectPageComponent),
        canActivate: [DemoRouteGuard]
      },
      {
        path: 'referral',
        redirectTo: 'accountValidation',
        pathMatch: 'full' 
      },
      // { 
      //   path: 'profil', 
      //   loadComponent: () => import('./pages/04-architect/00-profile/archi-edit-profil/archi-edit-profil.component').then(c => c.ArchiEditProfilComponent),
      //   canActivate: [ArchitectRouteGuard]
      // },
      // New profile pages structure 
      {
        path: 'profile',
        children: [
          { path: '', redirectTo: 'user', pathMatch: 'full' },
          { 
            path: 'user', 
            loadComponent: () => import('./pages/04-architect/00-profile/archi-profil/user-profile/user-profile.component').then(c => c.UserProfileComponent),
            canActivate: [ArchitectRouteGuard]
          },
          { 
            path: 'billing', 
            loadComponent: () => import('./pages/04-architect/00-profile/archi-profil/billing-management/billing-management.component').then(c => c.BillingManagementComponent),
            canActivate: [ArchitectRouteGuard]
          },
          { 
            path: 'settings', 
            loadComponent: () => import('./pages/04-architect/00-profile/archi-profil/settings-management/settings-management.component').then(c => c.SettingsManagementComponent),
            canActivate: [ArchitectRouteGuard]
          }
        ]
      },
      { 
        path: 'dpgf/:dpgfId', 
        loadComponent: () => import('./pages/04-architect/03-dce/archi-dpgf/archi-dpgf.component').then(c => c.ArchiDpgfNewComponent),
        canActivate: [ArchitectRouteGuard]
      },
      { 
        path: 'dpgf-version/:dpgfId', 
        loadComponent: () => import('./pages/04-architect/03-dce/archi-dpgf-version/archi-dpgf-version.component').then(c => c.ArchiDpgfVersionComponent),
        canActivate: [ArchitectRouteGuard]
      },
      { 
        path: 'dpgf-version-minor/:dpgfId', 
        loadComponent: () => import('./pages/04-architect/03-dce/archi-dpgf-minor-version/archi-dpgf-minor-version.component').then(c => c.ArchiDpgfMinorVersionComponent),
        canActivate: [ArchitectRouteGuard]
      },
      
      { 
        path: 'dpgf/:dpgfId/result', 
        loadComponent: () => import('./pages/04-architect/06-chiffrages/archi-dpgf-result/archi-dpgf-result.component').then(c => c.ArchiDpgfResultComponent),
        canActivate: [ArchitectRouteGuard], 
        children: [
          {
            path: '',
            redirectTo: 'hypothese',
            pathMatch: 'full'
          },
          { 
            path: 'chiffrage', 
            loadComponent: () => import('./pages/04-architect/06-chiffrages/_pages/dpgf-result-details/dpgf-result-details.component').then(c => c.DpgfResultDetailsComponent) 
          },
          { 
            path: 'comparatif', 
            loadComponent: () => import('./pages/04-architect/06-chiffrages/_pages/dpgf-result-summary/dpgf-result-summary.component').then(c => c.DpgfResultSummaryComponent) 
          },
          { 
            path: 'hypothese', 
            loadComponent: () => import('./pages/04-architect/06-chiffrages/_pages/dpgf-result-hypothese/dpgf-result-hypothese.component').then(c => c.DpgfResultHypotheseComponent)
          },
          { 
            path: 'graphique', 
            loadComponent: () => import('./pages/04-architect/06-chiffrages/_pages/dpgf-result-comparison/dpgf-result-comparison.component').then(c => c.DpgfResultComparisonComponent) 
          },
        ]
      },
      { 
        path: 'dpgf/:dpgfId/plans', 
        loadComponent: () => import('./pages/04-architect/03-dce/archi-plans-list/archi-plans-list.component').then(c => c.ArchiPlansListComponent),
        canActivate: [ArchitectRouteGuard]
      },
      { 
        path: 'dpgf/:dpgfId/plans/:planId', 
        loadComponent: () => import('./pages/04-architect/03-dce/archi-plan-measure/archi-plan-measure.component').then(c => c.ArchiPlanMeasureComponent),
        canActivate: [ArchitectRouteGuard]
      },
      {
        path: 'ce-project/:projectId/artisan',
        loadComponent: () => import('./pages/04-architect/04-enterprises/archi-ce-project-artisan/archi-ce-project-artisan.component').then(c => c.ArchiCeProjectArtisanComponent),
        canActivate: [ArchitectRouteGuard]
      },
      {
        path: 'ce-project/:projectId/fiche-ao',
        loadComponent: () => import('./pages/04-architect/07-fiche-ao/archi-fiche-ao/archi-fiche-ao.component').then(c => c.ArchiFicheAoComponent),
        canActivate: [ArchitectRouteGuard]
      },
      {
        path: 'ce-project/:projectId/analyse-offres',
        loadComponent: () => import('./pages/04-architect/05-analyse-offres/archi-analyse-offres/archi-analyse-offres.component').then(c => c.ArchiAnalyseOffresComponent),
        canActivate: [ArchitectRouteGuard]
      },
      {
        // Export of the state of a consultation (AG-2174), opened by « Exporter » in the Suivi des consultations
        path: 'ce-project/:projectId/artisan/export',
        loadComponent: () => import('./pages/04-architect/04-enterprises/consultation-export/consultation-export.component').then(c => c.ConsultationExportComponent),
        canActivate: [ArchitectRouteGuard]
      },
      {
        // Exports V2 of the offers analysis (AG-1740), opened from « Analyse des offres » and « Analyse détaillée » (?lot=)
        path: 'ce-project/:projectId/analyse-offres/export',
        loadComponent: () => import('./pages/04-architect/05-analyse-offres/act-export/act-export.component').then(c => c.ActExportComponent),
        canActivate: [ArchitectRouteGuard]
      },
      { 
        path: 'ce-project/:projectId/analyse-offres/lot/:lotId',
        loadComponent: () => import('./pages/04-architect/05-analyse-offres/archi-analyse-offres-lot/archi-analyse-offres-lot.component').then(c => c.ArchiAnalyseOffresLotComponent),
        canActivate: [ArchitectRouteGuard],
        // unsaved custom frames (AG-1768): « Modifications non enregistrées » before leaving the page or the lot
        canDeactivate: [(page: { canLeave(): boolean | Promise<boolean> } | null) => page?.canLeave() ?? true]
      },
      {
        // Planning v2 (features/planning, SPEC planning v2 §5.1) ; canDeactivate dans PLANNING_ROUTES.
        path: 'ce-project/:projectId/planning',
        loadChildren: () => import('./features/planning/planning.routes').then(m => m.PLANNING_ROUTES),
        canActivate: [ArchitectRouteGuard]
      },
      // Banc d’essai du planning (faux store, aucun appel API), hors production seulement.
      ...(!environment.production ? [{
        path: 'planning-banc',
        loadComponent: () => import('./features/planning/page/planning-banc.page').then(c => c.PlanningBancPage),
      }] : []),
      {
        // Connexions IA (features/ai-connections, 06-FRONT.md §6) : page de dépôt d’un fichier demandé par Claude
        // (jeton dans le fragment). Gardes dans AI_CONNECTIONS_ROUTES : le jeton quitte l’adresse avant la garde architecte.
        path: 'connexions-ia',
        loadChildren: () => import('./features/ai-connections/ai-connections.routes').then(m => m.AI_CONNECTIONS_ROUTES)
      },
      { 
        path: 'ce-project/:projectId', 
        loadComponent: () => import('./pages/04-architect/02-projectDash/project-dash.component').then(c => c.ProjectDashComponent),
        canActivate: [ArchitectRouteGuard]
      },
      { 
        path: 'ce-project/:projectId/payement', 
        loadComponent: () => import('./pages/04-architect/Deprecated/06-chantier/archi-ce-project-payement/archi-ce-project-payement.component').then(c => c.ArchiCeProjectPayementComponent),
        canActivate: [ArchitectRouteGuard]
      },
      { 
        path: 'ce-project/:projectId/chantier', 
        loadComponent: () => import('./pages/04-architect/Deprecated/06-chantier/archi-ce-project-chantier/archi-ce-project-chantier.component').then(c => c.ArchiCeProjectChantierComponent),
        canActivate: [ArchitectRouteGuard]
      },
      { 
        path: 'new-dpgf/:projectId',
        loadComponent: () => import('./pages/04-architect/03-dce/archi-new-dpgf/archi-new-dpgf.component').then(c => c.ArchiNewDpgfComponent),
        canActivate: [ArchitectRouteGuard]
      },
      { 
        path: 'new-dpgf-workflow/:projectId', 
        loadComponent: () => import('./pages/04-architect/03-dce/archi-new-dpgf-workflow/archi-new-dpgf-workflow.component').then(c => c.ArchiNewDpgfWorkflowComponent),
        canActivate: [ArchitectRouteGuard]
      },
      { 
        path: 'modify-ce-project/:projectId', 
        loadComponent: () => import('./pages/04-architect/01-projects/archi-modify-ce/archi-modify-ce.component').then(c => c.ArchiModifyCeComponent),
        canActivate: [ArchitectRouteGuard]
      },
      { 
        path: 'chantier-facture/:dpgfFactureId', 
        loadComponent: () => import('./pages/04-architect/Deprecated/06-chantier/archi-chantier-facture/archi-chantier-facture.component').then(c => c.ArchiChantierFactureComponent),
        canActivate: [ArchitectRouteGuard]
      },
      { 
        path: 'archi-db', 
        loadComponent: () => import('./pages/04-architect/00-profile/archi-db/archi-db.component').then(c => c.ArchiDbComponent),
        canActivate: [ArchitectRouteGuard]
      },
      { 
        path: 'reef-redirect', 
        loadComponent: () => import('./pages/04-architect/00-profile/archi-reef-redirect/archi-reef-redirect.component').then(c => c.ArchiReefRedirectComponent),
        canActivate: [ArchitectRouteGuard]
      },
      // { path: 'styles', component: StylesPageComponent },
      { 
        path: 'accountValidation', 
        loadComponent: () => import('./pages/02-signup/validation-account-architect/validation-account-architect.component').then(c => c.ValidationAccountArchitectComponent),
        canActivate: [NewAccountArchitectRouteGuard]
      },
      { 
        path: 'suggested-artisans/:ceProjectId', 
        loadComponent: () => import('./pages/04-architect/00-profile/suggeted-artisans/suggeted-artisans.component').then(c => c.SuggetedArtisansComponent),
        canActivate: [ArchitectRouteGuard]
      },
    ]
  },

  // Artisan
  { 
    path: 'artisan',
    children: [
      { 
        path: 'subscribe', 
        loadComponent: () => import('./pages/02-signup/artisan/artisan-subscribe-signup/artisan-subscribe-signup.component').then(c => c.ArtisanSubscribeSignupComponent),
        canActivate: [ExternalRouteGuard] 
      },
      { 
        path: 'subscribe2', 
        loadComponent: () => import('./pages/02-signup/artisan/artisan-subscribe-general/artisan-subscribe-general.component').then(c => c.ArtisanSubscribeGeneralComponent),
        canActivate: [ArtisanRouteGuard] 
      },
      { 
        path: 'subscribe2-agency', 
        loadComponent: () => import('./pages/02-signup/artisan/artisan-subscribe-agency-info/artisan-subscribe-agency-info.component').then(c => c.ArtisanSubscribeAgencyInfoComponent),
        canActivate: [ArtisanRouteGuard] 
      },
      { 
        path: 'subscribe3', 
        loadComponent: () => import('./pages/02-signup/artisan/artisan-subscribe-detail/artisan-subscribe-detail.component').then(c => c.ArtisanSubscribeDetailComponent),
        canActivate: [ArtisanRouteGuard] 
      },
      { 
        path: 'subscribe4', 
        loadComponent: () => import('./pages/02-signup/artisan/artisan-subscribe-file/artisan-subscribe-file.component').then(c => c.ArtisanSubscribeFileComponent),
        canActivate: [ArtisanRouteGuard] 
      },
      { 
        path: 'edit/profil', 
        loadComponent: () => import('./pages/03-artisan/00-profile/artisan-edit-profil/artisan-edit-profil.component').then(c => c.ArtisanEditProfilComponent),
        canActivate: [ArtisanRouteGuard] 
      },
      { 
        path: 'dpgf/:dpgfPricingId', 
        loadComponent: () => import('./pages/03-artisan/02-dpgf/artisan-price-dpgf/artisan-price-dpgf.component').then(c => c.ArtisanPriceDpgfComponent),
        canActivate: [] 
      },
      { 
        path: 'dpgf-version/:dpgfPricingId', 
        loadComponent: () => import('./pages/03-artisan/02-dpgf/artisan-version-dpgf/artisan-version-dpgf.component').then(c => c.ArtisanVersionDpgfComponent),
        canActivate: [] 
      },
      { 
        path: 'project-list', 
        loadComponent: () => import('./pages/03-artisan/04-projects/artisan-projects/artisan-projects.component').then(c => c.ArtisanProjectsComponent),
        canActivate: [ArtisanRouteGuard] 
      },
      { 
        path: 'project/:ceProjectInviteId', 
        loadComponent: () => import('./pages/03-artisan/04-projects/artisan-ce-project/artisan-ce-project.component').then(c => c.ArtisanCeProjectComponent),
        canActivate: [ArtisanRouteGuard] 
      },
      { 
        path: 'dpgf-chantier/:dpgfFactureId', 
        loadComponent: () => import('./pages/03-artisan/05-chantier/artisan-chantier/artisan-chantier.component').then(c => c.ArtisanChantierComponent),
        canActivate: [ArtisanRouteGuard]
      },
      { 
        path: 'booster-profile-forms', 
        loadComponent: () => import('./pages/03-artisan/03-booster/artisan-booster-profile-form-page/artisan-booster-profile-form-page.component').then(c => c.ArtisanBoosterProfileFormPageComponent),
        canActivate: [ArtisanRouteGuard] 
      },
      { 
        path: 'booster-profile', 
        loadComponent: () => import('./pages/03-artisan/03-booster/booster-profile-page/booster-profile-page.component').then(c => c.BoosterProfilePageComponent),
        canActivate: [ArtisanRouteGuard] 
      },
      { 
        path: 'user/:userId/delete-account', 
        loadComponent: () => import('./pages/03-artisan/00-profile/delete-account-artisan/delete-account-artisan.component').then(c => c.DeleteAccountArtisanComponent),
        canActivate: [ArtisanRouteGuard]
      }
    ]
  },
  // Admin
  { 
    path: 'admin',
    children: [
      { 
        path: 'createpassword/:userId', 
        loadComponent: () => import('./pages/05-admin/create-user-password/create-user-password.component').then(c => c.CreateUserPasswordComponent)
      }
    ]
  },
  // reef
  { 
    path: 'document/:doctype/:docId', 
    loadComponent: () => import('./pages/04-architect/00-profile/archi-reef-doc-redirect/archi-reef-doc-redirect.component').then(c => c.ArchiReefDocRedirectComponent)
  },
  // All
  {
    path: '',
    children: [
      { 
        path: '', 
        loadComponent: () => import('./pages/01-auth/login-page/login-page.component').then(c => c.LoginPageComponent),
        canActivate: [ExternalRouteGuard]
      },
      { 
        path: 'authorize', 
        loadComponent: () => import('./pages/01-auth/openid-connected-page/openid-connected-page.component').then(c => c.OpenidConnectedPageComponent)
      },
      { 
        path: 'login', 
        loadComponent: () => import('./pages/01-auth/login-page/login-page.component').then(c => c.LoginPageComponent),
        canActivate: [ExternalRouteGuard]
      },
      {
        path: 'consultation/:ceProjectId',
        loadComponent: () => import('./pages/07-public/public-consultation/public-consultation.component').then(c => c.PublicConsultationComponent)
      },
      {
        path: 'artisan-profil/:artisanId',
        loadComponent: () => import('./pages/03-artisan/03-booster/public-booster-profile/public-booster-profile.component').then(c => c.PublicBoosterProfileComponent),
        canActivate: [LoggedRouteGuard]
      },
      { 
        path: 'mot-de-passe-oublie', 
        loadComponent: () => import('./pages/01-auth/forgot-password/forgot-password.component').then(c => c.ForgotPasswordComponent),
        canActivate: [ExternalRouteGuard] 
      },
      { 
        path: 'reset-mot-de-passe/:token', 
        loadComponent: () => import('./pages/01-auth/reset-password/reset-password.component').then(c => c.ResetPasswordComponent),
        canActivate: [ExternalRouteGuard] 
      },
      { 
        path: 'no-multi-users', 
        loadComponent: () => import('./pages/00-errors/no-multiple-accounts-allowed/no-multiple-accounts-allowed.component').then(c => c.NoMultipleAccountsAllowedComponent) 
      },
      { 
        path: 'access-denied', 
        loadComponent: () => import('./pages/00-errors/403/403.component').then(c => c.accessDeniedComponent) 
      },
      { 
        path: 'entity-too-large', 
        loadComponent: () => import('./pages/00-errors/413/413.component').then(c => c.entityTooLargeComponent) 
      },
      { 
        path: 'server-error', 
        loadComponent: () => import('./pages/00-errors/500/500.component').then(c => c.serverError500Component) 
      },
      { 
        path: 'server-inaccessible', 
        loadComponent: () => import('./pages/00-errors/502/502.component').then(c => c.serverError502Component) 
      },
      { 
        path: 'error', 
        loadComponent: () => import('./pages/00-errors/error/error.component').then(c => c.ErrorComponent) 
      },
      {
        // Lien signé en lecture seule d’un indice du planning (Should, SPEC planning v2 §5.1).
        path: 'planning-partage/:token',
        loadComponent: () => import('./features/planning/public/public-share-page.component').then(c => c.PublicSharePageComponent)
      },
      { path: '**', component: notFoundComponent }
    ]
  }

];
